import { useEffect, useState } from "react";

// ページのリソースが完全に読み込まれたことを通知する Hooks
const useDocumentLoadCompleted = (): boolean => {
  const [isLoaded, setIsLoaded] = useState(false);
  const loaded = () => setIsLoaded(true);

  useEffect(() => {
    if (document.readyState === "complete") {
      loaded();
      return;
    }
    window.addEventListener("load", loaded);
    return () => {
      window.removeEventListener("load", loaded);
    };
  }, []);

  return isLoaded;
};

export default useDocumentLoadCompleted;
